import { render, staticRenderFns } from "./dataDicProperty.vue?vue&type=template&id=c13975ee&scoped=true&"
import script from "./dataDicProperty.vue?vue&type=script&lang=js&"
export * from "./dataDicProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13975ee",
  null
  
)

export default component.exports